export const REST_EXERCISE_ID = 99999;
